import axios from '@/axios';
import { eStorage } from '@beetronix/estorage';
import * as types from '../mutation-types';

export default {
	namespaced: true,

	state: {
		authenticated: false,
		self: {
			username: null,
		},
	},

	actions: {
		login({ commit }, { username, password }) {
			return axios.post('/user/authorization', { username, password }).then(({ data }) => {
				// todo:auth change to commit the refresh token
				commit(types.LOGIN, {
					username: data.username,
					token: data.token,
				});

				return data;
			});
		},
		logout({ commit }) {
			commit(types.LOGOUT);
		},
	},

	mutations: {
		[types.LOGIN](state, auth) {
			state.authenticated = true;
			state.self.username = auth.username;
			eStorage.l.set('auth', auth);
			axios.defaults.headers.common.Authorization = `Bearer ${auth.token}`;
		},
		[types.LOGOUT](state) {
			state.authenticated = false;
			state.self.username = null;
			eStorage.l.remove('auth');
			axios.defaults.headers.common.Authorization = undefined;
		},
	},
};
